export const RRSSLinks = [
    {
        name: 'WhatsApp',
        link: 'https://api.whatsapp.com/send?phone=59161561515',
        icon: 'bi-whatsapp',
        type: ['all', 'contact', 'default']
    },
    {
        name: 'Facebook',
        link: 'https://www.facebook.com/gamcochabamba',
        icon: 'bi-facebook',
        type: ['all', 'rrss', 'default']
    },
    {
        name: 'Instagram',
        link: 'https://www.facebook.com/gamcochabamba',
        icon: 'bi-instagram',
        type: ['all', 'rrss', 'default']
    },
    {
        name: 'Twitter',
        link: 'https://twitter.com/gam_cochabamba',
        icon: 'bi-twitter',
        type: ['all', 'rrss', 'default']
    },
    {
        name: 'YouTube',
        link: 'https://www.youtube.com/channel/UC6mQC2naSRZuNfuYvqKX2ow',
        icon: 'bi-youtube',
        type: ['all', 'multimedia']
    },
    {
        name: 'TikTok',
        link: 'https://www.tiktok.com/@alcaldiadecochabamba',
        icon: 'bi-tiktok',
        type: ['all', 'multimedia', 'default']
    },
    {
        name: 'LinkedIn',
        link: 'https://www.linkedin.com/company/gamc',
        icon: 'bi-linkedin',
        type: ['all', 'contact']
    },
    {
        name: 'Página Web',
        link: 'https://cochabamba.bo',
        icon: 'bi-globe',
        type: ['all', 'external']
    }
];
